import React from "react";

const CustomFilterInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  type = "text",
  id,
  icon: Icon = null,
  options = [],
  isSelect = false,
  renderOptions = null,
  error,
  touched,
  className,
  parentClassName="",
  hideErrorText = false,
  ...rest
}) => {
  const finalId = id || name;
  const hasError = error && (touched || error);
  // Red border only when hideErrorText is true
  const borderErrorClass =
    hideErrorText && hasError
      ? "!border-red-500 focus:ring-1 focus:ring-[red-500]"
      : "";
  return (
    <div className={parentClassName}>
      <label className="block font-semibold text-[12px] text-gray-700 mb-0.5 capitalize">
        {label}
      </label>
      {isSelect ? (
        <select
          className={` w-full rounded-[6px] py-[5px] !shadow-none px-[6px] border !border-gray-300 !bg-gray-100 !text-[12px] leading-tight placeholder:text-[12px] placeholder:leading-tight text-gray-700 placeholder:text-gray-700 focus:!ring-0 focus:!ring-primary focus:!border-primary outline-none ${borderErrorClass} ${className}`}
          id={finalId}
          name={name}
          onChange={onChange}
          value={value}
          onBlur={onBlur}
          {...rest}
        >
          <option value="">{placeholder}</option>
          {typeof renderOptions === "function"
            ? renderOptions()
            : options.map((option, index) => (
                <option key={index} value={option.id ?? option.value}>
                  {option.name}
                </option>
              ))}
        </select>
      ) : type === "textarea" ? (
        <textarea
          id={finalId}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          rows={3}
          {...rest}
          className={` !shadow-none w-full rounded-[6px] px-[6px] py-[5px] border !border-gray-300 !bg-gray-100 !text-[12px] leading-tight placeholder:!text-[12px] placeholder:leading-tight placeholder:text-gray-700 focus:!ring-0 focus:!ring-primary focus:!border-primary outline-none ${borderErrorClass} ${className}`}
        />
      ) : type === "date" ? (
        <input
          type="date"
          id={finalId}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          {...rest}
          className={` !shadow-none  w-full rounded-[6px] px-[6px] py-[5px] border !border-gray-300 !bg-gray-100 text-gray-800 !text-[12px] leading-tight placeholder:text-[12px] placeholder:leading-tight placeholder:!text-gray-700 focus:!ring-0 focus:!ring-primary focus:!border-primary outline-none ${borderErrorClass} ${className}`}
        />
      ) : (
        <input
          type={type}
          id={finalId}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          {...rest}
          className={` !shadow-none w-full rounded-[6px] px-[6px] py-[5px] border !border-gray-300 !bg-gray-100 !text-[12px] leading-tight placeholder:!text-[12px] placeholder:leading-tight placeholder:text-gray-700 focus:!ring-0 focus:!ring-primary focus:!border-primary outline-none ${borderErrorClass} ${className}`}
        />
      )}
      {hasError && !hideErrorText && (
        <p className="text-[10px] text-red-500 mt-1 font-medium">{error}</p>
      )}
    </div>
  );
};

export default CustomFilterInput;
